import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedAdminOrCreatorRoute from './components/ProtectedAdminOrCreatorRoute';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import GuidesPage from './pages/GuidesPage';
import GuideViewerPage from './pages/GuideViewerPage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import PeoplePage from './pages/PeoplePage';
import GuideBuilder from './pages/GuideBuilder';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import CallbackPage from './pages/CallbackPage';
import NotFoundPage from './pages/NotFoundPage';
import './styles/shepherd-theme.css';
import { ToastProvider } from '@heroui/react';

const App: React.FC = () => {
  return (
    <>
      <ToastProvider placement="bottom-center" />
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/products" element={<ProductsPage />} />
                    <Route path="/guides" element={<GuidesPage />} />
                    <Route path="/guides/:id" element={<GuideViewerPage />} />
                    <Route path="/courses" element={<CoursesPage />} />
                    <Route path="/courses/:id" element={<CourseDetailPage />} />
                    <Route path="/people" element={<PeoplePage />} />
                    <Route
                      path="/admin/guides/builder"
                      element={
                        <ProtectedAdminOrCreatorRoute>
                          <GuideBuilder />
                        </ProtectedAdminOrCreatorRoute>
                      }
                    />
                    <Route
                      path="/admin/guides/builder/:id"
                      element={
                        <ProtectedAdminOrCreatorRoute>
                          <GuideBuilder />
                        </ProtectedAdminOrCreatorRoute>
                      }
                    />
                    <Route
                      path="/admin/*"
                      element={
                        <ProtectedAdminOrCreatorRoute>
                          <AdminPage />
                        </ProtectedAdminOrCreatorRoute>
                      }
                    />
                    <Route path="/404" element={<NotFoundPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </>
  );
};

export default App;
